import { Component, OnInit } from "@angular/core";
import { MOSAR_URL } from "app/app-routing.module";
import { SYSTEM_PROOF_URLS } from "./system-proof-routing.module";
import { ErrorHandlerService } from "service/error-handler/error-handler.service";
import { ContainerService } from "app/shared/container.service";
import { map, take } from "rxjs";
import { ConstantsService } from "service/scenariomanager-api/constants.service";
import { ConfigureService } from "service/ng4-configure/ng4-configure.service";
import { ContainerInfo } from "model";
import { LibraryService } from "app/shared/library-service";
import { Router } from "@angular/router";


@Component({
  selector: "app-system-proof",
  templateUrl: "./system-proof.component.html",
  styleUrls: ["./system-proof.component.scss"]
  
})
export class SystemproofComponent implements OnInit {
  MOSAR_URL = MOSAR_URL;
  CAMPAIGNS_URL = '/' + MOSAR_URL.SYSTEM_PROOF+ '/' + SYSTEM_PROOF_URLS.CAMPAIGNS;
  SYSTEMPROOF_URL = '/' + MOSAR_URL.SYSTEM_PROOF+ '/' + SYSTEM_PROOF_URLS.CAMPAIGNS;
  USECASES_URL = '/' + MOSAR_URL.SYSTEM_PROOF + '/' + SYSTEM_PROOF_URLS.USECASES;
  SYSTEMS_URL = '/' + MOSAR_URL.SYSTEM_PROOF + '/' + SYSTEM_PROOF_URLS.SYSTEMS;
  TESTS_PROTOCOL_URL = '/' + MOSAR_URL.SYSTEM_PROOF + '/' + SYSTEM_PROOF_URLS.TESTS_PROTOCOLS;


  /* Systems variables */
  systems = [];
  systemSelected = null;

  /* campaigns variables */
  campaignContainers;
  campaignsLoaded = false;
  campaignPermission = null;
  campaignType: ContainerInfo = null;
  campaignSelected = null;

  /* testProtocols variables */
  testProtocols = [];
  testProtocolSelected = null;

  /* usecases variables */
  usecases = [];
  usecaseSelected = null;

  /* Documentation variables */
  docBaseUrl = "http://documentation-url/";
  supportEmail;
  

  constructor(
    private containerService: ContainerService,
    private errorHandlerService: ErrorHandlerService,
    private constantsService: ConstantsService,
    private libraryService: LibraryService,
    private configService: ConfigureService,
    private router: Router
  ) {
    this.campaignType = this.constantsService.getLibrariesInfo().filter(config => config.nameApi === 'campaign')[0];
    this.supportEmail = this.configService.config.supportEmail;
  }

  ngOnInit(): void {
    this.docBaseUrl = this.configService.config.documentationUrl;
    this.containerService.getContainers(this.campaignType.nameApi).pipe(take(1)).subscribe({
      next: (r) => {
        this.campaignContainers = r.map((c) => c.resources[0]);
        this.campaignContainers.forEach(container => {
          this.getCampaign(container, {
            filters:  null,
            container: container.id,
          })
        });
        this.campaignsLoaded = true;
      },
      error: (error) => {
        console.error(error);
        this.errorHandlerService.displayErrorPage({
          message: "Container cannot be fetched",
          button: "Return to home",
        });
      },
    });
  }

  mapSystemsToCampaigns() {
    // Each campaign has one or more systems
    // This function add a "nbCampaigns" property to each system
    // based on the number of campaigns that have this system
    this.systems.forEach(system => {
      system.nbCampaigns = 0;
      this.campaignContainers.forEach(container => {
        if(container.campaign && container.campaign.resources[0].systems && container.campaign.resources[0].systems[0].id === system.id) {
          system.nbCampaigns++;
        }
      });
    });
  }

  getCampaign(container, parameters) {
    this.libraryService
      .findLibrary(parameters,  this.campaignType.nameApi)
      .pipe(
        map(({ idContainer, permissions, resources, totalResults }) => {
          return { idContainer, resources, permissions, totalResults };
        })
      )
      .subscribe((res) => {
        container['campaign'] = res;
        if(res?.resources && res?.resources[0] && res?.resources[0].systems && res?.resources[0].systems[0]) {
          if(this.systems.filter( sys => sys.id === res?.resources[0].systems[0].id).length === 0) {
            this.systems.push(res?.resources[0].systems[0]);
          }
        }
        if(res?.resources && res?.resources[0] && res?.resources[0].testProtocols && res?.resources[0].testProtocols.length) {
          res?.resources[0].testProtocols.forEach(tp => {
            if(this.testProtocols.filter( tpExisting => tpExisting.id === tp.id).length === 0) {
              this.testProtocols.push(tp);
              if(tp?.testScenarios && tp?.testScenarios.length) {
                tp?.testScenarios.forEach(usecase => {
                  if(this.usecases.filter( ucExisting => ucExisting.usecase.id === usecase.usecase.id).length === 0) {
                    this.usecases.push(usecase);

                  }
                });
              }
            }
          });
        }
        this.mapSystemsToCampaigns();
      });
  }

  selectSystem(system) {
    if (this.systemSelected?.id === system?.id) {
      this.systemSelected = null;
      this.campaignSelected = null;
      this.testProtocolSelected = null;
      this.usecaseSelected = null;
    } else {
      this.systemSelected = system;
      this.campaignSelected = null;
      this.testProtocolSelected = null;
      this.usecaseSelected = null;
    }
  }

  selectCampaign(campaign) {
    if (this.campaignSelected?.id === campaign?.id) {
      this.campaignSelected = null;
      this.testProtocolSelected = null;
      this.usecaseSelected = null;
    } else {
      this.campaignSelected = campaign;
      this.testProtocolSelected = null;
      this.usecaseSelected = null;
    }
  }

  selectTestProtocol(tp) {
    if (this.testProtocolSelected?.id === tp?.id) {
      this.testProtocolSelected = null;
      this.usecaseSelected = null;
    } else {
      this.testProtocolSelected = tp;
      this.usecaseSelected = null;
    }
  }

  selectUsecase(uc) {
    if (this.usecaseSelected?.id === uc?.id) {
      this.usecaseSelected = null;
    } else {
      this.usecaseSelected = uc;
    }
  }

  redirectToCampaign(campaign) {
    const route = this.SYSTEMPROOF_URL + '/list/' + campaign.id;
    this.openInNewTab(route);
  }

  openInNewTab(url) {
    const urlToNavigate = this.router.serializeUrl(this.router.createUrlTree([url]));
    window.open(urlToNavigate, '_blank');
  }

  redirectToSystem(system) {
    if (system.path) {
     const containerId = system.path.split('/')[0];
     this.openInNewTab(this.SYSTEMS_URL + '/list/' + containerId + '/content/' + system.parent);
    } else {
      this.libraryService
      .getLibraryById(system.id, "drivingautomationsystem")
      .pipe(
        map(
          ({ idContainer, resources }) =>
            this.SYSTEMS_URL + '/list/' + idContainer + '/content/' + system.id
        ),
      ).subscribe(res => {
        this.openInNewTab(res);
      });
    }
  }

  redirectToTestProtocol(tp) {
    this.libraryService
    .getLibraryById(tp.id, "testprotocol")
    .pipe(
      map(
        ({ idContainer, resources }) =>
          this.TESTS_PROTOCOL_URL + '/list/' + idContainer + '/content/' + tp.id
      ),
    ).subscribe(res => {
      this.openInNewTab(res);
    });
  }

  redirectToUseCase(uc) {
    this.libraryService
    .getLibraryById(uc.usecase.id, "usecase")
    .pipe(
      map(
        ({ idContainer, resources }) =>
          this.USECASES_URL + '/list/' + idContainer + '/content/' + uc.usecase.id
      ),
    ).subscribe(res => {
      this.openInNewTab(res);
    });
  }

}